//App.tsx
import { auth } from "./firebaseConfig";
import React, { useEffect, useState } from 'react';
//import Navbar from './Navbar';
import { Link } from 'react-router-dom';
import logo from './logo192.png';
import './App.css';
import VietnamDataDisplay from './VietnamDataDisplay';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { User, onAuthStateChanged } from "firebase/auth";
//import { signOut } from "firebase/auth";
import Signup from './Signup';
import Signin from './Signin';
//import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import LmiaCheck from './LmiaCheck';
import ArtGenerator from "./ArtGenerator";
import RcicCheck from "./RcicCheck";
import CanCit from "./CanCit";
import ExpressEntry from "./ExpressEntry";


function App() {
  const [user, setUser] = useState<User | null>(null);
  // const handleSignOut = async () => {
  //   try {
  //     await signOut(auth);
  //     setUser(null);  // Reset the user state
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const handleGoogleSignIn = async () => {
  //   const provider = new GoogleAuthProvider();
  //   try {
  //     const result = await signInWithPopup(auth, provider);
  //     const user = result.user;
  //     if (user?.emailVerified) {
  //       setUser(user);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // Use inline styles for links for demonstration purposes
  // const linkStyle = {
  //   color: 'yellow',
  //   textDecoration: 'none',
  //   padding: '10px',
  //   fontWeight: 'bold',
  //   borderRadius: '5px',
  //   background: '#333', // A dark background for the buttons
  //   margin: '0 10px', // Add some space between the buttons
  //   // Add media query styles for screens smaller than 768px
  //   '@media (max-width: 768px)': {
  //     display: 'block', // Stack the links vertically
  //     textAlign: 'center', // Center align text for small screens
  //     margin: '10px 2px',
  //   },
  // };

  const linkStyle = {
    color: 'yellow', // White color for contrast
    textDecoration: 'none',
    padding: '10px 20px',
    fontWeight: 'bold',
    borderRadius: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.2)', // Semi-transparent white
    border: '1px solid rgba(255, 255, 255, 0.5)', // Subtle white border
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    transition: 'all 0.3s ease-in-out',
    margin: '0 10px',

    '@media (max-width: 768px)': {
      display: 'block',
      textAlign: 'center',
      margin: '10px auto',
      width: 'fit-content',
    },
  };

  // Hover Effect
  const handleMouseEnter = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.4)'; // Slightly darker on hover
    e.currentTarget.style.color = 'white'; // Change text color to black
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
    e.currentTarget.style.color = 'yellow'; // Revert text color to white
  };


  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user?.emailVerified) {  // Check if email is verified
        setUser(user);
      }
    });

    return () => unsubscribe();
  }, []);


  return (
    <BrowserRouter>
      {/* <Navbar user={user} handleSignOut={handleSignOut} handleGoogleSignIn={handleGoogleSignIn} /> */}
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="Logo" />
          <h1>Express Immigration Tools</h1>
          {/* {user && <button onClick={handleSignOut}>Sign Out</button>} */}
          {/* Dynamic inline styles for responsive design */}
          <div style={{ display: 'flex', flexDirection: window.innerWidth > 768 ? 'row' : 'column', justifyContent: 'center', gap: '5px' }}>
            <Link to="/" style={linkStyle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>FastTrack: IRCC Processing Times</Link>
            <Link to="/check-lmia" style={linkStyle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>FastCheck: LMIAs</Link>
            {/* <Link to="check-rcic" style={linkStyle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>FastCheck: RCICs</Link> */}
            <Link to="/express-entry" style={linkStyle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>FastTrack: Express Entry</Link>
            <Link to="/cancitpreparation" style={linkStyle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>FastPrep: Canadian Citizenship</Link>
            {/* <Link to="/art-generate" style={linkStyle} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>ArtGenerator</Link> */}
          </div>
          {/* Link to Sign Up */}
        </header>
        <main className="App-main">
          <Routes>
            <Route path="/signup" element={user ? <Navigate to="/" /> : <Signup />} />
            <Route path="/signin" element={user ? <Navigate to="/" /> : <Signin />} />
            <Route path="/" element={<VietnamDataDisplay />} />
            <Route path="/check-lmia" element={<LmiaCheck />} />
            <Route path="/check-rcic" element={<RcicCheck />} />
            <Route path="/cancitpreparation" element={<CanCit />} />
            <Route path="/express-entry" element={<ExpressEntry />} />
            <Route path="/art-generate" element={<ArtGenerator />} />
            {/* <Route path="/" element={user ? <VietnamDataDisplay /> : <Navigate to="/signin" />} /> */}
          </Routes>
        </main>
        <footer className="App-footer">
          <p>Copyright © 2023 DanVu</p>
          <a href="https://www.linkedin.com/in/danducvu/" target="_blank" rel="noreferrer" style={{ color: 'yellow' }}>LinkedIn</a>
          <a href="https://github.com/danvufs" target="_blank" rel="noreferrer" style={{ color: 'yellow' }}>GitHub</a>
        </footer>
        <Analytics />
      </div>
    </BrowserRouter>
  );
}

export default App;
